
import VButton from '~/components/ui/VButton'
import MeetingBooking from '~/components/modals/booking/MeetingBooking'
import EquipmentBooking from '~/components/modals/booking/EquipmentBooking'
import WorkplaceBooking from '~/components/modals/booking/WorkplaceBooking'
import SubscriptionsBooking from '~/components/modals/booking/SubscriptionsBooking'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        color: {
            type: String,
            default: 'default'
        }
    },
    computed: {
        ...mapGetters('profile', [
            'role',
        ]),
        ...mapState('profile', [
            'isAuthorized'
        ]),
        price() {
            return this.item.prices.map(el => `${el.formatted}`).join(' / ')
        },
        modalComponent() {
            switch (this.item.type) {
                // case 'workplace':
                //     return WorkplaceBooking
                // case 'meeting':
                // case 'conference':
                //     return MeetingBooking
                // case 'subscriptions':
                //     return SubscriptionsBooking
                // case 'equipment':
                //     return EquipmentBooking
                // default:
                //     return WorkplaceBooking
                case 'booking':
                    return MeetingBooking
                case 'one_time':
                    return SubscriptionsBooking
            }
        },
        modalDescription() {
            switch (this.item.type) {
                // case 'workplace':
                //     return 'Please, select place and date of visit'
                // case 'meeting':
                // case 'conference':
                //     return 'Minimal time to book a meeting room is 1 hour'
                // case 'subscriptions':
                //     return 'Please choose your membership type'
                // case 'equipment':
                //     return 'Minimal time to book is 1 hour'
                // default:
                //     return 'Please, select place and date of visit'
                case 'booking':
                    return this.$t('booking.booking')
                case 'one_time':
                    return this.$t('booking.oneTime')
            }
        }
    },
    methods: {
        ...mapActions('booking', [
            'bookingClean'
        ]),
        booking() {
            if (this.isAuthorized) {
                this.$modal.show(
                    this.modalComponent,
                    {
                        item: this.item,
                        buttons: [{
                            title: this.$t('general.ok'),
                            handler: () => {
                                this.$modal.hide('coworking-booking')
                            }
                        }]
                    }, {
                        maxWidth: 480,
                        adaptive: true,
                        clickToClose: false,
                        height: 'auto',
                        name: 'coworking-booking',
                    },
                    { 'before-close': () => {
                        this.bookingClean()
                    } }
                )
            } else {
                window.open(this.glLoginUrl(), '_self');
            }
        }
    },
    components: {
        VButton
    }
}
